import React from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import { patchImageSlider, deleteImageSlider } from 'redux/image-sliders/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import InstagramSliderItemHeaderContent
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderItemHeaderContent';
import InstagramSliderItemExpandedContent
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderItemExpandedContent';

function InstagramSiderItem(props) {
  const { item, patchImageSlider, deleteImageSlider } = props;

  return (
    <div className="instagram-slider-item__component">
      <CommonLinkContainer
        linkItem={item}
        allowExpand
        patchLinkFunction={patchImageSlider}
        headerContent={
          <InstagramSliderItemHeaderContent
            key={`instagram-slider-item-header-content-key-${item.id}`}
            item={item}
            deleteImageSlider={deleteImageSlider}
          />
        }
        expandedContent={
          <InstagramSliderItemExpandedContent
            key={`instagram-slider-item-expanded-content-key-${item.id}`}
            item={item}
            deleteImageSlider={deleteImageSlider}
          />
        }
      />
    </div>
  );
}

InstagramSiderItem.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  deleteImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
    deleteImageSlider,
  },
)(InstagramSiderItem);
